/**
 * Experiment names for A/B testing and feature experimentation.
 * Used for analytics tracking and experiment identification.
 */
export const EXPERIMENTS = {
  AVENTRIA_LANDING_PAGE: 'aventria_landing_page',
  SURGEON_GROUPING: 'surgeon_grouping',
} as const;

export type ExperimentName = (typeof EXPERIMENTS)[keyof typeof EXPERIMENTS];
